// extracted by mini-css-extract-plugin
export var addButton = "_gt-0";
export var border = "_gt-8";
export var check = "_gt-h";
export var danger = "_gt-6";
export var dropdownContainer = "_gt-1";
export var editModalBody = "_gt-j";
export var footerContainer = "_gt-i";
export var fullWidth = "_gt-a";
export var hide = "_gt-9";
export var icon = "_gt-3";
export var input = "_gt-7";
export var inputFlex = "_gt-b";
export var inputWrapper = "_gt-c";
export var manualFocus = "_gt-5";
export var optionButton = "_gt-4";
export var pillWrapper = "_gt-e";
export var pointer = "_gt-2";
export var showOverflow = "_gt-f";
export var tagsFlex = "_gt-d";
export var xButton = "_gt-g";